import React, { FunctionComponent } from 'react';
import { useTranslation } from 'next-i18next';

import { GorgiasOrderStatusEnum } from '../../../lib/ssp/types';

import { STATUS_COLOR } from './constants';
import Status from './styled';

export type FulfillmentStatusProps = {
  status: GorgiasOrderStatusEnum;
};

const FulfillmentStatus: FunctionComponent<FulfillmentStatusProps> = ({
  status,
}) => {
  const { t } = useTranslation();
  return (
    <Status color={STATUS_COLOR[status]}>
      {t(`fulfillmentStatus.${status}`)}
    </Status>
  );
};

export default FulfillmentStatus;
